import script from "./TypeFormList.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeFormList.vue?vue&type=script&setup=true&lang=js"

import "./TypeFormList.vue?vue&type=style&index=0&id=472e5336&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472e5336"]])

export default __exports__